import { render } from "./import-face-dialog.vue?vue&type=template&id=a1d7f176&ts=true"
import script from "./import-face-dialog.vue?vue&type=script&lang=ts"
export * from "./import-face-dialog.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__